import type { PlatformTypeName } from "@multi-chat/shared";
import { ChannelIdentityBadge } from "../../components/channel/ChannelIdentityBadge.js";
import { SimpleSelect } from "../../components/ui/select/index.js";

const ALL = "__ALL__";

export function ReportChannelSelect({
  value,
  platforms,
  onChange,
  allLabel,
  channelLabel,
  labelForPlatform,
  ariaLabel,
  testId,
}: {
  value?: PlatformTypeName;
  platforms: readonly PlatformTypeName[];
  onChange: (platform: PlatformTypeName | undefined) => void;
  allLabel: string;
  channelLabel: string;
  labelForPlatform: (platform: PlatformTypeName) => string;
  ariaLabel: string;
  testId?: string;
}): React.JSX.Element {
  return (
    <label className="grid w-full min-w-0 gap-0.5 text-[0.75rem]" data-testid={testId}>
      <span className="text-muted">{channelLabel}</span>
      <SimpleSelect
        value={value ?? ALL}
        onValueChange={(next) =>
          onChange(next === ALL ? undefined : (next as PlatformTypeName))
        }
        ariaLabel={ariaLabel}
        triggerClassName="h-8 w-full min-w-0 rounded-md border-line/70 text-start text-[0.75rem]"
        options={[
          { value: ALL, label: allLabel },
          ...platforms.map((platform) => ({
            value: platform,
            label: (
              <span className="inline-flex items-center gap-2">
                <ChannelIdentityBadge platformType={platform} size="filter" />
                {labelForPlatform(platform)}
              </span>
            ),
          })),
        ]}
      />
    </label>
  );
}
